import { render } from "./ExerciseMappingPanel.vue?vue&type=template&id=1ca3e436&scoped=true"
import script from "./ExerciseMappingPanel.vue?vue&type=script&lang=js"
export * from "./ExerciseMappingPanel.vue?vue&type=script&lang=js"

import "./ExerciseMappingPanel.vue?vue&type=style&index=0&id=1ca3e436&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca3e436"]])

export default __exports__